// Generated from backend/workers/core-backend/port-manifest.json. Do not edit:
// change a status there, then run `node scripts/routed-functions.ts` from
// backend/workers/core-backend (Node 24).

export const ROUTED_FUNCTIONS_OPT_IN: readonly string[] = [];

export const ROUTED_FUNCTIONS_EVERYONE: readonly string[] = [];
